import { createAction, props } from '@ngrx/store';

export const enum NFCDeviceActionTypes {
  loadNFCDevicesAction = '[NFC] Load NFC Devices',
  loadNFCDevicesSuccessAction = '[NFC] Load NFC Devices Success',
  loadNFCDevicesErrorAction = '[NFC] Load NFC Devices Error',

  createNFCDeviceAction = '[NFC] Create NFC Device',
  createNFCDeviceSuccessAction = '[NFC] Create NFC Device Success',
  createNFCDeviceErrorAction = '[NFC] Create NFC Device Error',

  updateNFCDeviceAction = '[NFC] Update NFC Device',
  updateNFCDeviceSuccessAction = '[NFC] Update NFC Device Success',
  updateNFCDeviceErrorAction = '[NFC] Update NFC Device Error',

  clearNFCDevicesSuccessErrorDataAction = '[NFC] Clear NFC Devices Actions',
}

export const loadNFCDevicesBegin = createAction(
 NFCDeviceActionTypes.loadNFCDevicesAction
);

export const loadNFCDevicesSuccess = createAction(
 NFCDeviceActionTypes.loadNFCDevicesSuccessAction,
  props<{ payload: any }>()
);

export const loadNFCDevicesError = createAction(
 NFCDeviceActionTypes.loadNFCDevicesErrorAction,
  props<{ payload: any }>()
);


export const createNFCDeviceBegin = createAction(
 NFCDeviceActionTypes.createNFCDeviceAction,
  props<{ payload: any }>()
);

export const createNFCDeviceSuccess = createAction(
 NFCDeviceActionTypes.createNFCDeviceSuccessAction,
  props<{ card: any }>()
);

export const createNFCDeviceError = createAction(
 NFCDeviceActionTypes.createNFCDeviceErrorAction,
  props<{ payload: any }>()
);

export const updateNFCDeviceBegin = createAction(
  NFCDeviceActionTypes.updateNFCDeviceAction,
   props<{ payload: any }>()
 );
 
 export const updateNFCDeviceSuccess = createAction(
  NFCDeviceActionTypes.updateNFCDeviceSuccessAction,
   props<{ card: any }>()
 );
 
 export const updateNFCDeviceError = createAction(
  NFCDeviceActionTypes.updateNFCDeviceErrorAction,
   props<{ payload: any }>()
 );

export const clearNFCDevicesSuccessErrorData = createAction(
 NFCDeviceActionTypes.clearNFCDevicesSuccessErrorDataAction
);
